import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/styles/index.scss' // global css

import md5 from 'md5'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { openApplyDialog } from './utils/applyDialog'

Vue.config.productionTip = false
Vue.prototype.$md5 = md5


import './permission' // permission control

import piugin from './components/index'  //导入全局组件

Vue.use(piugin)
//全局引入字体：Lenovo-XiaoxinChaokuGB
Vue.prototype.$fontFamily = "Lenovo-XiaoxinChaokuGB"; //字体名称    
Vue.use(ElementUI);

// 全局方法：gourl，任何页面都可以调用
Vue.prototype.$gourl = function(url) {
    // 新开一个窗口，跳转第三方地址
    window.open(url, '_blank');
};

Vue.prototype.$openApplyDialog = function(payload) {
    openApplyDialog(payload)
};

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
